<template>
	<nk-wrapper v-if="context" spacing="md">
		<nk-title v-if="context.titel" size="4xl" tag="h1">
			{{ context.titel }}
		</nk-title>

		<div v-if="context.text" class="nk-cms-content" v-html="context.text" />
		<div class="clear-both" />
	</nk-wrapper>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';
import {useCMS, updateBreadcrumb, useSEO} from '#nk/composables/cms';

/**
 * @prop {object} context
 */
export default {
	name: 'TemplateWegweiserVerfahrenDetail',
	mixins: [TemplatesDefault],

	setup(ctx) {
		const page = useCMS();

		const verfahren = {
			titel: ctx?.context?.titel || '',
		};

		if (verfahren.titel) {
			updateBreadcrumb({
				title: verfahren.titel,
			});
		}

		useSEO({
			title: `${page.value.title} ${verfahren.titel}`,
		});
	},
};
</script>
